import {
    FileText,
    FileImage,
    FileSpreadsheet,
    Presentation as FilePpt,
    FileArchive,
    FileAudio,
    FileVideo,
    FileCode,
    FileIcon as FilePdf,
    File,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export function getFileIcon(filename: string): LucideIcon {
    const extension = filename.split('.').pop()?.toLowerCase() || '';

    switch (extension) {
        // Documents
        case 'pdf':
            return FilePdf;
        case 'doc':
        case 'docx':
        case 'txt':
        case 'rtf':
        case 'odt':
            return FileText;

        // Spreadsheets
        case 'xls':
        case 'xlsx':
        case 'csv':
        case 'ods':
            return FileSpreadsheet;

        // Presentations
        case 'ppt':
        case 'pptx':
        case 'odp':
            return FilePpt;

        // Images
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
        case 'bmp':
        case 'svg':
        case 'webp':
            return FileImage;

        // Archives
        case 'zip':
        case 'rar':
        case 'tar':
        case 'gz':
        case '7z':
            return FileArchive;

        // Audio
        case 'mp3':
        case 'wav':
        case 'ogg':
        case 'm4a':
        case 'flac':
            return FileAudio;

        // Video
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'wmv':
        case 'mkv':
        case 'webm':
            return FileVideo;

        // Code
        case 'js':
        case 'ts':
        case 'jsx':
        case 'tsx':
        case 'html':
        case 'css':
        case 'php':
        case 'py':
        case 'java':
        case 'c':
        case 'cpp':
        case 'json':
        case 'xml':
            return FileCode;

        // Default
        default:
            return File;
    }
}
